import React, { useState, useEffect, useRef } from 'react';
import i18next from '../../i18n.js';
import { showModalDialog, hideModalDialog } from '../ModalDialog.js';
import { getFieldSetting } from '../helpers/HelperFunctions.js';

const PinIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 21c4.5-4.2 7-7.4 7-11a7 7 0 10-14 0c0 3.6 2.5 6.8 7 11z" />
        <circle cx="12" cy="10" r="2.5" />
    </svg>
);

const ChevronRightIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#B4B4B4" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 5l7 7-7 7" />
    </svg>
);

const StartingPointForm = (props) => {
    const { cityFieldName, mainPlaceFieldName, secondaryCityFieldName, commentFieldName } = props;

    const [city, setCity] = useState(props.value?.[cityFieldName] ?? '');
    const [secondaryCity, setSecondaryCity] = useState(props.value?.[secondaryCityFieldName] ?? '');
    const [mainPlace, setMainPlace] = useState(props.value?.[mainPlaceFieldName] !== false);
    const [comment, setComment] = useState(props.value?.[commentFieldName] ?? '');

    const mainPlacePrevValue = useRef(props.value?.[mainPlaceFieldName] !== false);

    useEffect(() => {
        if (mainPlacePrevValue.current !== mainPlace) {
            if (mainPlace) {
                if (secondaryCity) {
                    setCity(secondaryCity);
                }
            }
            else {
                if (city) {
                    setSecondaryCity(city);
                }
            }
            mainPlacePrevValue.current = mainPlace;
        }
    }, [mainPlace]);

    const saveHandle = () => {
        const value = { ...props.value };
        if (cityFieldName) value[cityFieldName] = city;
        if (secondaryCityFieldName) value[secondaryCityFieldName] = secondaryCity;
        if (mainPlaceFieldName) value[mainPlaceFieldName] = mainPlace;
        if (commentFieldName) value[commentFieldName] = mainPlace ? '' : comment;
        props.onSave(value);
    }

    return (<div className="starting-point-form">
        <div className="starting-point-title">{i18next.t('form.fields.startingPointTitle')}</div>
        {mainPlace && <div className="starting-point-city">
            <input className="form-control" value={city} placeholder={i18next.t('form.fields.startingPointCityPlaceholder')} onChange={(e) => { setCity(e.target.value);}} />
        </div>}
        {!mainPlace && <div className="starting-point-city">
            <input className="form-control" value={secondaryCity} placeholder={i18next.t('form.fields.startingPointCityPlaceholder')} onChange={(e) => { setSecondaryCity(e.target.value) }} />
        </div>}
        <div className="starting-point-label">{i18next.t('form.fields.startingPointWorkPlace')}</div>
        <div className="starting-point-radio" onClick={() => setMainPlace(true)}>
            <span>{i18next.t('form.fields.startingPointMainPlace')}</span>
            <div className={'radio' + (mainPlace ? ' checked' : '')} />
        </div>
        <div className="starting-point-radio" onClick={() => setMainPlace(false)}>
            <span>{i18next.t('form.fields.startingPointNotMainPlace')}</span>
            <div className={'radio' + (!mainPlace ? ' checked' : '')} />
        </div>
        {!mainPlace && commentFieldName && <>
            <div className="starting-point-label">{i18next.t('form.fields.startingPointCommentLabel')}</div>
            <textarea className="starting-point-comment" autoFocus value={comment} placeholder={i18next.t('form.fields.startingPointCommentPlaceholder')} onChange={(e) => setComment(e.target.value)} />
            <div className="starting-point-hint">{i18next.t('form.fields.startingPointCommentHint')}</div>
        </>}
        <button type="button" className="btn starting-point-save" onClick={saveHandle}>{i18next.t('save')}</button>
    </div>);
}

const StartingPointInput = (props) => {
    const { name, value, settings, disabled } = props;

    const cityFieldName = getFieldSetting(settings, 'MainCityField');
    const secondaryCityFieldName = getFieldSetting(settings, 'SecondaryCityField');
    const mainPlaceFieldName = getFieldSetting(settings, 'MainPlaceField');
    const commentFieldName = getFieldSetting(settings, 'CommentField');

    const secondaryCity = value?.[secondaryCityFieldName];
    const mainPlace = value?.[mainPlaceFieldName] !== false;
    const city = value?.[mainPlace ? cityFieldName : secondaryCityFieldName];
    const comment = value?.[commentFieldName];

    const saveHandle = (newValue) => {
        hideModalDialog('modalDialog');
        if (props.onChange) props.onChange({ target: { name: name, value: newValue } });
    }

    const openPopupHandle = () => {
        if (disabled) return;
        showModalDialog('modalDialog', "", "",
            <StartingPointForm value={value} cityFieldName={cityFieldName} secondaryCityFieldName={secondaryCityFieldName} mainPlaceFieldName={mainPlaceFieldName} commentFieldName={commentFieldName} onSave={saveHandle} />,
            "starting-point-popup", true, []);
    }

    return (<div className={"starting-point-input" + (disabled ? " disabled" : "")}>
        <div className="starting-point-control" onClick={openPopupHandle}>
            <PinIcon />
            {mainPlace && <span className={city ? '' : 'empty'}>{city ? i18next.t('form.fields.startingPointValue', { city: city }) : i18next.t('form.fields.startingPointEmpty')}</span>}
            {!mainPlace && <span className={secondaryCity ? '' : 'empty'}>{secondaryCity ? i18next.t('form.fields.startingPointValue', { city: secondaryCity }) : i18next.t('form.fields.startingPointEmpty')}</span>}
            <ChevronRightIcon />
        </div>
        {city && !mainPlace && commentFieldName && <div className="starting-point-comment-preview" onClick={openPopupHandle}>
            <div className="label">{i18next.t('form.fields.startingPointCommentPreviewLabel')}</div>
            <div className={comment ? 'text' : 'text empty'}>{comment ? comment : i18next.t('form.fields.startingPointCommentPreviewEmpty')}</div>
        </div>}
    </div>);
}

export default StartingPointInput;
